import { useState, useEffect } from 'react';
import Util from "../../Service/util";
import Service from "../../Service/http";
import { toast } from "react-toastify";
import { Link } from 'react-router-dom';
import { FcDownload } from 'react-icons/fc';
import * as xlsx from "xlsx";
import { FadeLoader } from "react-spinners";


function DeleteMentor() {

    const service = new Service();
    const util = new Util();
    let [ loading, SetLoading] = useState(false);
    let [ data, SetData ] = useState([]);
    useEffect(() => {
        let isLogin = util.loggedIn();
        let admin = util.isAdmin();
        if (!isLogin && window.location.pathname !== "/login" || !admin) {
            window.location.replace("/login");
        }
        if (isLogin && admin) {

            
        }

    }, []);

    const HandleSubmit = () => {
        if(Object.keys(data).length === 0){
            toast.error("Please upload a file");
            return;
        }
        SetLoading(true);
        if(data.length > 0){
            const body = {
                data : data
            }
        service
            .post("api/users/bulkdelete/mentors", body)
            .then((json) => {
                SetLoading(false);
                toast.success(`Deleted Mentors of ${json.modifiedCount} Users Updated Successfully`);
            }).catch((error) => {
                SetLoading(false);
                toast.error(error);
            })
        }
        else{
            toast.error("Please upload a file");
        }
    }

    const handleFileUpload = (e) => {
        try{
            e.preventDefault();
            if (e && e.target && e.target.files && e.target.files[0]) {
            const reader = new FileReader();
            reader.onload = (e) => {
                const data = e.target.result;
                const workbook = xlsx.read(data, { type: "array" });
                const sheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[sheetName];
                const json = xlsx.utils.sheet_to_json(worksheet);
                SetData(json);
            };
            reader.readAsArrayBuffer(e.target.files[0]);
            }
        }
        catch(err){
            console.log(err);
        }
    };


    return (
        <>
            {
                loading
                    ? <div style={{ marginTop: "10vh", marginRight:"10vh",textAlign:"center"}}><FadeLoader  margin={5} color="green" /></div>
                    :
                    <div className='card' style={{ "marginTop": "5%", marginLeft: "2%", marginRight: "2%" }}>
                        <h1 className='text-center card-title text-primary' style={{ "margin": "2%" }}>Delete Mentor Mentees</h1>
                        <div >
                            <div className="container text-center card-body" >

                                <div className="row row-cols-1" >
                                    <div className="col">
                                    </div>
                                    <div className="col">

                                    <div>
                                    <Link
                                        className="float-start mb-2"
                                        to="/files/Sample-Mentor-Delete.xlsx"
                                        target="_blank"
                                        download
                                    >
                                        {" "}
                                        <FcDownload /> Download Sample{" "}
                                    </Link>
                                    <div className=" my-2">
                                    <input
                                        className="form-control"
                                        type="file"
                                        placeholder="Upload Mentors for Users"
                                        accept=".csv,.xlsx,.xls"
                                        onChange={(e)=>{
                                        handleFileUpload(e)
                                            }
                                        }
                                    />
                                    </div>
                                    <button
                                    onClick={() => {
                                        HandleSubmit();
                                    }}
                                    className="btn btn-success float-end "
                                    >
                                    DELETE MENTORS
                                    </button>
                                </div></div>
                                </div>
                                
                            </div>
                        </div>
                    </div>
            }
        </>
    )
}

export default DeleteMentor;